export default __webpack_public_path__ + "static/media/ringtone.15727de3.mp3";